import { z } from 'zod';

export enum LifeEventType {
  BIRTH_OR_ADOPTION = 'BIRTH_OR_ADOPTION',
  DEMOTION = 'DEMOTION',
  DIVORCE = 'DIVORCE',
  DEATH = 'DEATH',
  ENROLLMENT_EVENT = 'ENROLLMENT_EVENT',
  LOSS_OF_COVERAGE = 'LOSS_OF_COVERAGE',
  MARRIAGE = 'MARRIAGE',
  NEWLY_ELIGIBLE = 'NEWLY_ELIGIBLE',
  PROMOTION = 'PROMOTION',
  INCOME_CHANGES = 'INCOME_CHANGES',
  CHANGE_IN_CONTRACTED_HOURS = 'CHANGE_IN_CONTRACTED_HOURS',
  MOVING_HOME = 'MOVING_HOME',
  OVERSEAS_SECONDMENT = 'OVERSEAS_SECONDMENT',
  RETURN_FROM_OVERSEAS_SECONDMENT = 'RETURN_FROM_OVERSEAS_SECONDMENT',
  RETURN_TO_WORK = 'RETURN_TO_WORK',
  OTHER = 'OTHER',
  UNPAID_SICKNESS_OR_LEAVE = 'UNPAID_SICKNESS_OR_LEAVE',
}

export enum LifeEventStatus {
  ACTION_REQUIRED = 'ACTION_REQUIRED',
  PARTIALLY_APPROVED = 'PARTIALLY_APPROVED',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  AUTO_APPROVED = 'AUTO_APPROVED',
}

export enum LifeEventSource {
  MANUAL = 'MANUAL',
  AUTO_TRIGGERED = 'AUTO_TRIGGERED',
}

export const benefitNameSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export const benefitsNamesSchema = z.array(benefitNameSchema);

export type BenefitsNames = z.infer<typeof benefitsNamesSchema>;

const lifeEventsSchema = z.object({
  lifeEvents: z.array(z.nativeEnum(LifeEventType)),
});

export type LifeEvents = z.infer<typeof lifeEventsSchema>;
